import type { CSSProperties } from "react";
import { Outlet } from "react-router-dom";
import { AdminI18n } from "@/components/admin/AdminI18n";
import { AdminSearch } from "@/components/admin/AdminSearch";
import { AdminTabs } from "@/components/admin/AdminTabs";
import { EnvBanner } from "@/components/admin/EnvBanner";
import { useAdminT } from "@/components/admin/useAdminT";
import { useShowKeys } from "@/components/admin/useShowKeys";

const WRAP: CSSProperties = {
  minHeight: "100dvh",
  background: "var(--d-ink)",
  color: "var(--d-fg)",
  paddingBottom: 96,
};
const BAR: CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 16,
  padding: "0 24px",
  flexWrap: "wrap",
};
const TOGGLE: CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 6,
  fontFamily: "var(--font-body)",
  fontSize: 13,
  color: "var(--d-fg)",
  whiteSpace: "nowrap",
};

function AdminChrome(): JSX.Element {
  const t = useAdminT();
  const { showKeys, toggle } = useShowKeys();
  return (
    <div style={WRAP}>
      <EnvBanner />
      <AdminTabs />
      <div style={BAR}>
        <AdminSearch />
        <label style={TOGGLE}>
          <input type="checkbox" checked={showKeys} onChange={toggle} />
          {t("shell.show_keys")}
        </label>
      </div>
      <Outlet />
    </div>
  );
}

/** Root of the admin UI: everything below renders in English regardless of the product language. */
export function AdminLayout(): JSX.Element {
  return (
    <AdminI18n>
      <AdminChrome />
    </AdminI18n>
  );
}
